export default {
  colors: {
    primary_50: "#e6f5ed",
    primary_600: "#23a168",
    primary_800: "#007153",
    black_800: "#323232",
    yellow: "#ffb000",
    yellow_50: "#fff0cc",
    yellow_100: "#fff0cc",
    yellow_200: "#ffd980",
    yellow_300: "#ffc94d",
    yellow_400: "#ffa726",
    yellow_450: "#ffb300",
    yellow_500: "#ffc94d",
    yellow_600: "#d69400",
    yellow_900: "#805900",
    red_450: "#ca3f60",
    red_800: "#851431",
    green_100: "#e1eee9",
    green_300: "#9ec9b7",
    green_400: "#19ac8a",
    green: "#0b9b7a",
    green_800: "#188068",
    brown: "#7d5f4f",
    orange: "#ff5217",
    purple_light: "#a487e1",
    purple: "#b051b7",
    dark_black: "#000",
    black: "#1a1a1a",
    complementary_900: "#1a1a1a",
    complementary_dark: "#333333",
    complementary_800: "#333333",
    complementary_700: "#5f6366",
    complementary_600: "#898989",
    complementary_500: "#898989",
    complementary_450: "#b9b9b9",
    complementary_400: "#dddddd",
    complementary_300: "#d9d9d9",
    complementary_250: "#ebebeb",
    complementary_200: "#ebebeb",
    complementary_light: "#fcfcfc",
    complementary_100: "#f2f2f2",
    complementary_50: "#fafafa",
    complementary: "#ffffff",
    primary_dark: "#007153",
    primary_700: "#1c8255",
    primary: "#23a168",
    primary_500: "#37ae72",
    primary_400: "#50c384",
    primary_vivid: "#1c8255",
    primary_300: "#5fd39f",
    primary_200: "#85e0b6",
    primary_100: "#c3efdb",
    primary_light: "#c3efdb",
    primary_050: "#e6f5ed",
    tertiary_800: "#0049b1",
    tertiary_700: "#0060e6",
    tertiary_650: "#0080ff",
    tertiary_600: "#1b73e4",
    tertiary_500: "#2699fb",
    tertiary_400: "#6abafb",
    tertiary_300: "#83c5fc",
    tertiary_200: "#b4dcfd",
    tertiary_100: "#cde8fe",
    tertiary_50: "#e6f3fe",
    red_700: "#851431",
    red_600: "#a90021",
    red: "#b33f53",
    red_500: "#dd2c00",
    red_400: "#ca3f60",
    red_200: "#e49eaf",
    red_150: "#fbe9e7",
    red_100: "#ebc6cd",
    red_50: "#f8ecef",
    red_10: "#f8f1f5",
    grape_purple: "#b051b7",
    lilac: "#a487e1",
    indigo_blue: "#435ca6",
    denim_blue: "#6481d6",
    light_blue: "#e5eaf8",
    tomato_red: "#dd2c00",
    white: "#ffffff",
    purple_lighten_5: "#F3E5F5",
    purple_darken_3: "#6A1B9A",
    blue_grey_darken_3: "#37474F",
    blue_grey_lighten_5: "#ECEFF1",
    green_lighten_5: "#E8F5E9",
    green_darken_3: "#2E7D32",
    blue_darken_3: "#1565C0",
    blue_lighten_5: "#BBDEFB",
    deep_orange_lighten_5: "#FBE9E7",
    deep_orange_darken_3: "#D84315"
  },
  font_sizes: {
    giant: "32px",
    x4_large: "28px",
    x3_large: "24px",
    x2_5_large: "22px",
    x2_large: "20px",
    large: "18px",
    x2_medium: "16px",
    x1_medium: "15px",
    x_medium: "14px",
    medium: "13px",
    x_small: "12px",
    small: "11px",
    little: "8px"
  },

  font_weight: {
    bold: 600,
    medium: 500,
    regular: 400,
    light: 300,
    x_light: 200
  }
};
